import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import store from "store"
import { setState as setUiState } from "store/ui"
import useInterval from "hooks/useInterval"
// import { setState as setSocketState } from "store/socket";
import { v4 as uuid } from "uuid"
import qs from "query-string"
import Firebase from "scripts/util/Firebase"
import EventPubSub from "scripts/util/EventPubSub"
import GA from "scripts/util/GA"

import Landing from "components/Landing"
import CharacterSelect from "components/CharacterSelect"
import Intro from "components/Intro"
import Instructions from "components/Instructions"
import Outro from "components/Outro"
import Results from "components/Results"
import Game3D from "components/Game3D"

import "./TemplateMain.scss"
import AudioManager from "scripts/util/AudioManager"
import ModalLeaderboard from "components/ModalLeaderboard"

function TemplateMain(props) {
  // const { connected, paired } = useSelector((state) => state.socket)
  const { gameDuration, winner } = useSelector((state) => state.game)

  const [view, setView] = useState(() => {
    const query = qs.parse(window.location.search)
    if (query.view && query.view === "character") {
      return "character"
    }
    if (query.view && query.view === "game") {
      return "game"
    }
    return "landing"
  })
  const [duration, setDuration] = useState(0)

  const winnerRef = useRef(null)
  const durationRef = useRef(0)
  const gameDurationRef = useRef(0)

  useInterval(() => {
    setDuration(duration + 1)
  }, 1000)

  useEffect(() => {
    durationRef.current = duration
  }, [duration])
  useEffect(() => {
    gameDurationRef.current = gameDuration
  }, [gameDuration])
  useEffect(() => {
    winnerRef.current = winner
  }, [winner])

  // TODO: connect to db
  useEffect(() => {
    Firebase.init(uuid())
  }, [])

  useEffect(() => {
    if (view !== "results") {
      GA.trackScreen(view)
    } else {
      if (winner) {
        GA.trackScreen("results-winner")
      } else {
        GA.trackScreen("results-not-winner")
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view])

  function goBack(view) {
    console.log("Go Back:", view)
    switch (view) {
      case "character":
        setView("landing")
        return
      case "intro":
        setView("character")
        return
      case "instructions":
        setView("intro")
        return
      case "game":
        EventPubSub.emit("resume")
        return
      default:
      // do nothing
    }
  }

  const exitGame = () => {
    GA.trackEvent("Mobile Game Stats", "Duration", durationRef.current)
    GA.trackEvent("Mobile Game Stats", "Game Duration", gameDurationRef.current)

    // Give GA time to execute
    setTimeout(() => {
      window.location.href = "https://unlock.att.com/"
    }, 750)
  }

  const playAgain = (callback) => {
    if (callback) {
      callback()
    }

    GA.trackEvent("Mobile Game Stats", "Duration", durationRef.current)
    GA.trackEvent("Mobile Game Stats", "Game Duration", gameDurationRef.current)

    // Give GA time to execute
    setTimeout(() => {
      window.location.reload()
    }, 750)
  }

  useEffect(() => {
    // setView("instructions")

    AudioManager.playTrack("uiMusic", 0.1)
    EventPubSub.subscribe("exitGame", exitGame)
    EventPubSub.subscribe("playAgain", playAgain)
    EventPubSub.subscribe("goBack", goBack)
    return () => {
      EventPubSub.unsubscribe("exitGame", exitGame)
      EventPubSub.unsubscribe("playAgain", playAgain)
      EventPubSub.subscribe("goBack", goBack)
    }
  }, [])

  return (
    <div className="TemplateMain">
      {view === "landing" && (
        <Landing
          onComplete={() => {
            setView("character")
          }}
          // paired={paired}
          // connected={connected}
        />
      )}

      {view === "character" && (
        <CharacterSelect
          onComplete={() => {
            setView("intro")
          }}
        />
      )}

      {view === "intro" && (
        <Intro
          onComplete={() => {
            setView("instructions")
          }}
        />
      )}

      {view === "instructions" && (
        <Instructions
          onComplete={(val) => {
            if (val === "back") {
              setView("landing")
            } else {
              setView("game")
            }
          }}
        />
      )}

      {view === "game" && (
        <Game3D
          onComplete={(state) => {
            AudioManager.playTrack("uiMusic", 0.1)
            if (winnerRef.current) {
              setView("outro")
            } else {
              setView("results")
            }
          }}
        />
      )}

      {view === "outro" && (
        <Outro
          onComplete={() => {
            setView("results")
          }}
        />
      )}

      {view === "results" && (
        <Results
          onComplete={() => {
            window.location.reload(false)
          }}
        />
      )}

      <ModalLeaderboard
        showPlay={view === "landing" || view === "character"}
        onComplete={(state) => {
          AudioManager.playSound("uiAccept")
          setView("character")
          store.dispatch(setUiState({ showLeaderboard: false }))
        }}
      />
    </div>
  )
}

export default TemplateMain
